import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const StyledSection = styled.section`
  text-align: center;
  p {
    margin: 0;
    font-size: 1.1rem;
  }
  span {
    font-size: 1.2rem;
  }
  a {
    font-size: 1.1rem;
  }
  a,
  a:focus {
    text-decoration: none;
    border: 0;
    outline: 0;
  }
  a:hover {
    color: ${props => props.theme.palette.actionableSecondary};
  }

  &:last-of-type {
    margin-bottom: 0;
  }
`;
